enum ComponentId {
  FootfallPinnedLocations = "FootfallPinnedLocations",
  FootfallPerEntrance = "FootfallPerEntrance",
  FootfallEvolution = "FootfallEvolution",
  Footfall = "Footfall",
  OccupancyLastHour = "OccupancyLastHour",
  WeatherEventsInfluence = "WeatherEventsInfluence",
  IntervalTabsWithDatepicker = "IntervalTabsWithDatepicker",
}

export default ComponentId;
